module.exports = __webpack_public_path__ + "img/trash.bb635ecd.svg";